angular.module('mercury.layouts', []);
